__turbopack_context__.v({
  "avatar": "Avatar-module-scss-module__hdo0YW__avatar",
  "icon": "Avatar-module-scss-module__hdo0YW__icon",
  "image": "Avatar-module-scss-module__hdo0YW__image",
  "initials": "Avatar-module-scss-module__hdo0YW__initials",
  "size-lg": "Avatar-module-scss-module__hdo0YW__size-lg",
  "size-md": "Avatar-module-scss-module__hdo0YW__size-md",
  "size-sm": "Avatar-module-scss-module__hdo0YW__size-sm",
});
